define(['../appContext', '../utils/tools'],
function (app, tools) {
    "use strict";

    var s = {};

    s.allSecurities = new tools.dictionary();

    return s;
});
